import { render, staticRenderFns } from "./sockPrint.vue?vue&type=template&id=00a61ca6&scoped=true&"
import script from "./sockPrint.vue?vue&type=script&lang=js&"
export * from "./sockPrint.vue?vue&type=script&lang=js&"
import style0 from "./sockPrint.vue?vue&type=style&index=0&id=00a61ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a61ca6",
  null
  
)

export default component.exports